module.exports = __webpack_public_path__ + "img/48.f5112386.jpg";